import { render, staticRenderFns } from "./Profit.vue?vue&type=template&id=3452f706&scoped=true&"
import script from "./Profit.vue?vue&type=script&lang=js&"
export * from "./Profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452f706",
  null
  
)

export default component.exports